  const revealEls = document.querySelectorAll('[data-reveal]');
  if('IntersectionObserver' in window){
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{
        if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, {threshold:0.15});
    revealEls.forEach(el=>io.observe(el));
  } else {
    revealEls.forEach(el=>el.classList.add('in'));
  }

  // Product page: swap main image when a thumbnail is clicked
  const mainImg = document.getElementById('lsp-main-image');
  document.querySelectorAll('.lsp-thumb-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(mainImg && btn.dataset.full){ mainImg.src = btn.dataset.full; }
    });
  });
